import React, { useState, useEffect } from "react";
import './style.css';
import ScheduleMeetingModal from "../ScheduleMeetingModal";
import { Col, Dropdown, Button, Row, Space, Tooltip } from "antd";
import { DownOutlined } from '@ant-design/icons';
import { useDispatch } from "react-redux";
import { alertService } from "../Alert";
import moment from "moment";
import { getNumberWithUnit } from "@hedgefund/shared";

const items = [
  {
    label: "In Person",
    key: 'person',
  },
  {
    label: "Virtual Meeting",
    key: 'zoom',
  },
];
const AllocatorProfileHeader = ({ allocatorId, AllocatorProfileDetails, onClickFollowAllocatorHandler, follow, createAppointment, loading, getAllocatorUsers, getHedgeFundUsers, getAdminUsers }) => {
  const [modalState, setModalState] = useState();
  const [visibleMeetingModal, setVisibleMeetingModal] = useState(false);

  const { allocatorDetail, allocatorUsers, hedgefundUsers, adminUsers, isSchedule } = AllocatorProfileDetails;
  const dispatch = useDispatch();

  const onClickModal = (type) => {
    setModalState(type?.key);
    setVisibleMeetingModal(true);
  }
  const onSuccess = () => {
    alertService.success("Meeting created successfully!", { autoClose: true });
  }
  const newAppointment = (data, onSuccess) => {
    if (modalState === "zoom") {
      const newData = { ...data, Type: 0 };
      dispatch(createAppointment(newData, onSuccess));
    }
    if (modalState === "person") {
      const newData = { ...data, Type: 1 };
      dispatch(createAppointment(newData, onSuccess));
    }
  };

  return (
    <Row style={{ minHeight: "800px",backgroundColor: "#fff", borderRadius: "10px", marginLeft: "50px", padding: "10px", border: "1px solid #edeef0" }}>
      <Col span={24}>
        <img
          id="cover_image"
          style={{height : "200px"}}
          className="logo-style"
          src={
              allocatorDetail?.logo ?
                allocatorDetail?.logo :
                "/assets/images/bg1.png"
          }
          alt="Company Logo"
        />
      </Col>
      <Col span={24} style={{marginTop:"-250px"}}>
        <Row className="text-center mt-2">
          <Col span={24} className="text-center">
            <div className="Fund-FontSize" style={{ fontSize: "26px" }}>{allocatorDetail?.name}</div>
            <h4>{allocatorDetail?.address}</h4>
          </Col>
          <Col span={23} offset={1} className="text-center ">
            <Row>
              <Col span={24} className="p-2">
              {isSchedule && (
              <Dropdown
                type="primary"
                className="schedule-meeting"
                menu={{ items, onClick: onClickModal }}
                trigger={['click']}
                onOpenChange={() => {
                  dispatch(getAllocatorUsers(allocatorId));
                  dispatch(getHedgeFundUsers());
                  dispatch(getAdminUsers());
                }}
              >
                <a style={{ color: "#fff" }} onClick={(e) => e.preventDefault()}>
                  <Space>
                    Schedule
                    <DownOutlined />
                  </Space>
                </a>
              </Dropdown>
            )}
            <Button
              style={{ height: "48px", borderRadius: "5px" }}
              type="primary"
              className="schedule-meeting ml-2"
              onClick={onClickFollowAllocatorHandler}
            > <Space>
              </Space>{follow ? "Followed" : "+ Follow"}
            </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="text-center mt-2">
          <Col span={8}>
            <div className="Fund-FontSize">{`${allocatorDetail?.aum !== null ? getNumberWithUnit(allocatorDetail?.aum) : "N/A"}`}</div>
            <h4>AUM</h4>
          </Col>
          <Col span={8} style={{ borderLeft: "2px solid #c1c1c1", borderRight: "2px solid #c1c1c1" }}>
            <div className="Fund-FontSize">{allocatorDetail?.investorTypeName ? allocatorDetail?.investorTypeName : "N/A"}</div>
            <h4> {"Investor Type"}</h4>
          </Col>
          <Col span={8}>
            <div className="Fund-FontSize">{allocatorDetail?.foundedDate ? moment(allocatorDetail?.foundedDate, "YYYY-MM-DD").format("LL") : "N/A"}</div>
            <h4>Founded Date</h4>
          </Col>
        </Row>
        <Row className="ml-4 mt-2">
          <Col span={9} offset={1}>
            <div class="ml-2 Fund-FontSize">
              <i className="fa fa-phone mr-1"></i>
              {allocatorDetail?.phoneNumber ? allocatorDetail?.phoneNumber : "N/A"}
            </div>
          </Col>
          <Col span={14}>
            <div class="ml-2 Fund-FontSize" >
              <i className="fa fa-globe mr-1"></i>
              {allocatorDetail?.websiteUrl ? allocatorDetail?.websiteUrl : "N/A"}
            </div>
          </Col>
          <Col span={24}>
            <div className="ml-2 mt-4">
              <b className="Fund-FontSize">Overview</b> :
              <div className="ml-2" style={{ fontSize: "12px", width: "90%" }}>{allocatorDetail?.companyInfo ? allocatorDetail?.companyInfo : "N/A"}</div>
            </div>
          </Col>
        </Row>
      </Col>
      <ScheduleMeetingModal
        allocatorManagers={allocatorUsers}
        name={allocatorDetail?.name}
        admin={adminUsers}
        hedgefundUsers={hedgefundUsers}
        allocatorId={allocatorId}
        newAppointment={newAppointment}
        loading={loading}
        title={
          modalState === "zoom"
            ? " Schedule a FCN Virtual Meeting"
            : " Schedule a In Person Meeting"
        }
        Visible={visibleMeetingModal}
        setVisibility={setVisibleMeetingModal}
      />
    </Row>
    // <div className="cover-profile">
    //   <div>
    //     <div class="image-container">
    //       <img style={{ height: "325px" }} src={coverImg} alt="Cover Image" />
    //     </div>
    //     {/* <img className="profile-bg-img img-fluid" style={{ height: "300px" }} src={coverImg} alt="Cover Image" /> */}
    //     <div className="card-block user-info">
    //       <div className="col-md-12" style={{ marginTop: "40px" }}>
    //         <div className="media-left">

    //           <div className="profile-image overlay-container">
    //             <img className="profile-pg-img" src={companyLogo} alt="Profile Image" />
    //           </div>
    //         </div>
    //         <div className="media-body row" style={{ backgroundImage: "linear-gradient(to bottom, #e7e7e76b , #0000005c)", padding: "20px", marginLeft: "2px" }}>
    //           <div className="col-lg-12">
    //             <div className="user-title">
    //               <h2 style={{ color: '#ffffff' }}> <a style={{ color: '#ffffff' }} href={allocatorDetail?.websiteUrl} target="_blank" > {allocatorDetail?.name} </a></h2>
    //               <span className="text-white">{allocatorDetail?.address}</span>
    //             </div>
    //           </div>
    //         </div>
    //         <div className="pull-right cover-btn">
    //           <Row>
    //             <Col span={12} style={{ marginTop: "13px" }}>
    //               {isSchedule && (
    //                 <Dropdown
    //                   type="primary"
    //                   className="schedule-meeting"
    //                   menu={{ items, onClick: onClickModal }}
    //                   trigger={['click']}
    //                   onOpenChange={() => {
    //                     dispatch(getAllocatorUsers(allocatorId));
    //                     dispatch(getHedgeFundUsers());
    //                     dispatch(getAdminUsers());
    //                   }}
    //                 >
    //                   <a style={{ color: "#fff" }} onClick={(e) => e.preventDefault()}>
    //                     <Space>
    //                       Schedule
    //                       <DownOutlined />
    //                     </Space>
    //                   </a>
    //                 </Dropdown>
    //               )}
    //             </Col>
    //             <Col span={10} className="ml-3">
    //               <Button
    //                 // btnName={follow ? "Followed" : "+ Follow"}
    //                 style={{ height : "47px", borderRadius:"5px" }}
    //                 type="primary"
    //                 className="schedule-meeting"
    //                 onClick={onClickFollowAllocatorHandler}
    //               > <Space>
    //             </Space>{follow ? "Followed" : "+ Follow"}
    //               </Button>
    //             </Col>
    //           </Row>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <ScheduleMeetingModal
    //     allocatorManagers={allocatorUsers}
    //     name={allocatorDetail?.name}
    //     admin={adminUsers}
    //     hedgefundUsers={hedgefundUsers}
    //     allocatorId={allocatorId}
    //     newAppointment={newAppointment}
    //     loading={loading}
    //     title={
    //       modalState === "zoom"
    //         ? " Schedule a FCN Virtual Meeting"
    //         : " Schedule a In Person Meeting"
    //     }
    //     Visible={visibleMeetingModal}
    //     setVisibility={setVisibleMeetingModal}
    //   />
    // </div>
  );
};

export default AllocatorProfileHeader;
